<div class="head-w">
    <div class="offerschedule">
        <mat-icon class="unsetico">event</mat-icon>
        <span multilang class="offerscheduletext">
            <ng-container *ngIf="datas?.dauer > 0">
                <b>{{datas?.dauer + (datas?.dauer > 1 ? ' Tage' : ' Tag')}}</b>
            </ng-container>
            {{datas?.hinflugs?.[0]?.startDate | date:'dd.MM.yyyy'}}
            {{ datas?.ruckflugs?.length > 0 ? ' - ' + (datas.ruckflugs[0].startDate | date:'dd.MM.yyyy'): ''}}
        </span>
    </div>
    <div class="offerinfos">
        <div>
            <ng-container *ngIf="datas?.validTo?.length > 0">
                <div class="fvalidtow">
                    <mat-icon class="ficon mright">event_available</mat-icon>
                    <span multilang class="ftext">Gültig bis {{datas.validTo | date:'EEE, dd.MM.yyyy
                        HH:mm'}}</span>
                </div>
            </ng-container>
            <!--span class="fpadlr mtop" style="font-size: .8rem;">Flug</span-->
            <div class="fdropw mtop mbottom">
                <mat-icon class="ficon">flight_takeoff</mat-icon>
                <span multilang class="fpadlr">
                    <b>{{datas?.hinflugs?.[0]?.departureAirport?.name}}</b>
                    ({{datas?.hinflugs?.[0]?.departureAirport?.code}})
                </span>
            </div>
            <ng-container *ngIf="datas?.ruckflugs?.length > 0; else oneway">
                <div class="fdropw mbottom">
                    <mat-icon class="ficon">flight_land</mat-icon>
                    <span multilang class="fpadlr">
                        <b>{{datas.ruckflugs[0].departureAirport?.name}}</b>
                        ({{datas.ruckflugs[0].departureAirport?.code}})
                    </span>
                </div>
            </ng-container>
            <ng-template #oneway>
                <div class="fdropw mbottom">
                    <mat-icon class="ficon">flight_land</mat-icon>
                    <span multilang class="fpadlr">
                        <b>{{datas?.hinflugs?.[datas.hinflugs.length - 1]?.arrivalAirport?.name}}</b>
                        ({{datas?.hinflugs?.[datas.hinflugs.length - 1]?.arrivalAirport?.code}})
                    </span>
                </div>
            </ng-template>
            <mat-divider></mat-divider>
            <div class="fdropw mtop">
                <mat-icon class="ficon">airlines</mat-icon>
                <span multilang class="fpadlr">{{datas?.hinflugs?.[0]?.carrier}}</span>
            </div>
            <div class="fdropw mtop">
                <mat-icon class="ficon">luggage</mat-icon>
                <span multilang class="fpadlr">{{datas?.hinflugs?.[0]?.gepack}}</span>
            </div>
            <div class="fdropw mtop">
                <mat-icon class="ficon">class</mat-icon>
                <span multilang class="fpadlr">{{datas?.hinflugs?.[0]?.cabinClass}}</span>
            </div>
            <div class="fdropw mtop">
                <mat-icon class="ficon">airline_stops</mat-icon>
                <span multilang class="fpadlr">{{datas?.hinflugs?.length - 1}} Stopp</span>
            </div>
        </div>
    </div>
    <div class="offerprice">
        <span multilang>
            <span multilang *ngIf="datas?.adult?.length > 0">Erwachsene : {{datas?.adult}}</span>
            <span multilang style="margin-left: .5rem;" *ngIf="datas?.childrenCount?.length > 0">Kinder :
                {{datas?.childrenCount}}</span>
        </span>
        <div class="offerpriceTotal">
            <span multilang>Gesamtpreis:</span>
            <span multilang class="prccolor">{{datas?.price | number:'1.2-2'}} {{datas?.currency}}</span>
        </div>
    </div>
</div>